import { Card, CardContent, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { Repeat } from "lib/@components/repeat"
import Iconify from "minimals-template/components/Iconify"
import { ConditionChip } from "./condition-chip"
import { ActionDisplay } from "./action-display"

export function AiGeneratedRulePreview({ item: rule }) {
    return (
        <Card variant="outlined" sx={{ bgcolor: "action.hover" }}>
            <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                <Stack spacing={1}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Iconify icon="mdi:auto-fix" sx={{ fontSize: 18, color: "primary.main" }} />
                        <Typography variant="subtitle2" fontWeight={600}>
                            {rule.name || "Unnamed Rule"}
                        </Typography>
                    </Stack>
                    <If value={rule.conditions?.length > 0}>
                        <Stack spacing={0.5} sx={{ pl: 1 }}>
                            <Repeat list={rule.conditions} item={<ConditionChip />} />
                        </Stack>
                    </If>
                    <If value={rule.action}>
                        <ActionDisplay action={rule.action} />
                    </If>
                </Stack>
            </CardContent>
        </Card>
    )
}
